import React from "react";
import Card, { cx } from "../../features/ui/Card";
import Pill from "../../features/ui/Pill";
import Chevron from "../ui/Chevron";
import ModuleTable from "./ModuleTable";

export default function YearAccordion({
  yearIndex,
  levelKey,
  required,
  total,
  modules,
  minGrade,
  isOpen,
  onToggle,
  onAddModule,
  onUpdateModule,
  onClampModule,
  onRemoveModule,
  onLoadPreset,
  onClearAll,
}) {
  const ok = total === required;

  return (
    <Card>
      <button
        type="button"
        onClick={onToggle}
        className="flex w-full items-center justify-between gap-3 px-6 py-4 text-left"
      >
        <div className="min-w-0">
          <div className="flex flex-wrap items-center gap-2">
            <h2 className="text-base font-semibold text-neutral-900 dark:text-neutral-50">
              Year {yearIndex}
            </h2>
            <Pill className="uppercase">{levelKey}</Pill>
            <Pill>{required} credits</Pill>
            <Pill>
              Total:{" "}
              <span
                className={cx(
                  "ml-1 font-semibold",
                  ok ? "text-neutral-900 dark:text-neutral-50" : "text-red-600"
                )}
              >
                {total}
              </span>
            </Pill>
          </div>

          <p className="mt-1 text-sm text-neutral-600 dark:text-neutral-400">
            Add your modules for this year. Credits must total exactly {required}.
          </p>
        </div>

        <div className="flex items-center gap-2">
          {!ok ? (
            <span className="hidden rounded-lg bg-red-50 px-2 py-1 text-xs font-semibold text-red-700 dark:bg-red-950/40 dark:text-red-200 sm:inline">
              Credits mismatch
            </span>
          ) : null}
          <Chevron open={isOpen} />
        </div>
      </button>

      {isOpen ? (
        <div className="px-6 pb-6">
          <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
            <div className="text-sm text-neutral-600 dark:text-neutral-400">
              Enter a grade and credits for each module.
            </div>

            <button
              type="button"
              onClick={onAddModule}
              className="
                inline-flex items-center justify-center rounded-xl border border-neutral-200
                bg-white px-3 py-2 text-sm font-medium text-neutral-800 hover:bg-neutral-100
                dark:border-neutral-800 dark:bg-neutral-950 dark:text-neutral-100 dark:hover:bg-neutral-900
              "
            >
              + Add module
            </button>
          </div>

          <ModuleTable
            modules={modules}
            minGrade={minGrade}
            requiredCredits={required}
            onUpdateModule={onUpdateModule}
            onClamp={onClampModule}
            onRemoveModule={onRemoveModule}
          />

          {/* Footer row: error (left) + actions (right) */}
          <div className="mt-3 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
            <div className="text-sm">
              {!ok ? (
                <span className="text-red-600">
                  Credits must total exactly {required} for {levelKey.toUpperCase()}.
                </span>
              ) : (
                <span className="text-neutral-500 dark:text-neutral-400">
                  Credits total matches requirement.
                </span>
              )}
            </div>

            <div className="flex items-center justify-end gap-2">
              <button
                type="button"
                onClick={onLoadPreset}
                className="
                  inline-flex items-center justify-center rounded-xl border border-neutral-200
                  bg-white px-3 py-2 text-sm font-medium text-neutral-800 hover:bg-neutral-100
                  dark:border-neutral-800 dark:bg-neutral-950 dark:text-neutral-100 dark:hover:bg-neutral-900
                "
                title="Fill this year with 15-credit modules totaling the required credits"
              >
                Load preset
              </button>

              <button
                type="button"
                onClick={onClearAll}
                className="
                  inline-flex items-center justify-center rounded-xl border border-neutral-200
                  bg-white px-3 py-2 text-sm font-medium text-neutral-800 hover:bg-neutral-100
                  dark:border-neutral-800 dark:bg-neutral-950 dark:text-neutral-100 dark:hover:bg-neutral-900
                "
                title="Remove all modules for this year"
              >
                Clear all
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </Card>
  );
}